import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { isElement } from "./auth-service-tools175.js";
import "react";
import { useProps } from "./auth-service-tools225.js";
import { factory } from "./auth-service-tools248.js";
import { Popover } from "./auth-service-tools264.js";
import { useComboboxContext } from "./auth-service-tools332.js";
const defaultProps = {
  refProp: "ref"
};
const ComboboxDropdownTarget = factory((props, ref) => {
  const {
    children,
    refProp
  } = useProps("ComboboxDropdownTarget", defaultProps, props);
  useComboboxContext();

  if (!isElement(children)) {
    throw new Error("Combobox.DropdownTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
  }

  return /* @__PURE__ */jsxRuntimeExports.jsx(Popover.Target, {
    ref,
    refProp,
    children
  });
});
ComboboxDropdownTarget.displayName = "@mantine/core/ComboboxDropdownTarget";
export { ComboboxDropdownTarget };